// extracted by mini-css-extract-plugin
module.exports = {"netIcon":"NetworkIcon_netIcon__3TdRW","iconAnimation":"NetworkIcon_iconAnimation__2m99I"};